import { render, staticRenderFns } from "./IssueDetailDescriptionPc.vue?vue&type=template&id=4955a5f0&"
import script from "./IssueDetailDescriptionPc.vue?vue&type=script&lang=ts&"
export * from "./IssueDetailDescriptionPc.vue?vue&type=script&lang=ts&"
import style0 from "./IssueDetailDescriptionPc.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VChip,VSheet})
